import locales from "../locales/localization.json";

export type LocalizationType = typeof locales;

export const useSharedReportingLocalization = (): LocalizationType => locales;
